import Vue from 'vue'
import Router from 'vue-router'
import VueRouter from "vue-router";
import NProgress from "nprogress";

const Backend = require('../views/Layout/Backend.vue') /*后端布局页*/
const Front = require('../views/Layout/Front.vue')  /*前端布局页*/

Vue.use(Router)

let routes = [
    /*==前台路由配置 Start==*/
    {
        path: '/',
        redirect: '/luck-draw',
        component: Front,
        hidden: true,
        index: 0,
        children: [
            {
                path: 'login',
                component: require('../views/userLogin.vue'),
                name: 'login',
                meta: {
                    title: '用户登陆',
                    isBackend: false,
                    mustAuth: false,
                    showNav: false,
                    hidden: true,
                    index: 0,
                },
            },
            {
                path: 'luck-draw',
                component: require('../views/lucky-drawer/MyLuckDraw.vue'),
                name: 'luck-draw',
                meta: {
                    title: '会员抽奖',
                    isBackend: false,
                    mustAuth: false,
                    showNav: false,
                    hidden: true,
                    index: 3,
                },
            },
            {
                path: 'luck-draw-activity',
                component: require('../views/lucky-drawer-activity/MyLuckDraw.vue'),
                name: 'luck-draw-activity',
                meta: {
                    title: '会员抽奖',
                    isBackend: false,
                    mustAuth: false,
                    showNav: false,
                    hidden: true,
                    index: 5,
                },
            },
            {
                path: 'promotion',
                component: require('../views/Promotion.vue'),
                name: 'promotion',
                meta: {
                    title: '大额返现',
                    isBackend: false,
                    mustAuth: false,
                    showNav: false,
                    hidden: true,
                    index: 4
                },
            },
            {
                path: 'epmc',
                component: require('../views/performance.vue'),
                name: 'epmc',
                meta: {
                    title: '填写工时',
                    isBackend: false,
                    mustAuth: true,
                    hiddenToolbar: false,
                    showNav: true,
                    hidden: true,
                    index: 1,
                },
            },
            {
                path: 'changePwd',
                component: require('../views/changePassword.vue'),
                name: 'changePwd',
                meta: {
                    title: '修改密码',
                    isBackend: false,
                    mustAuth: true,
                    showNav: true,
                    hidden: true,
                    index: 2,
                }
            },
        ]
    },

    /*==前台路由配置 End==*/

    /*==管理后台路由配置 Start==*/
    {
        path: '/admin/login',
        component: require('../views/admin/login.vue'),
        name: 'admin_login',
        meta: {
            title: '系统登陆',
            isBackend: true,
            mustAuth: false
        },
        hidden: true,
        index: 0,
    },
    {
        path: '/admin',
        component: Backend,
        name: 'admin',
        meta: {
            title: '绩效管理',
            isBackend: true,
            mustAuth: true,
        },
        iconCls: 'el-icon-message',//图标样式class
        index: 0,
        redirect: '/admin/project',
        children: [
            {
                path: 'project',
                name: 'project',
                component: require('../views/admin/project/projectManage.vue'),
                meta: {
                    title: '项目信息管理',
                    isBackend: true,
                    mustAuth: true
                },
                index: 1,
            },
            {
                path: 'customer',
                name: 'customer',
                component: require('../views/admin/customer/customerManage.vue'),
                meta: {
                    title: '客户信息',
                    isBackend: true,
                    mustAuth: true
                },
                index: 2,
            },
            {
                path: 'elc',
                name: 'elc',
                component: require('../views/admin/elc/employeeLevelConfig.vue'),
                meta: {
                    title: '员工级别配置',
                    isBackend: true,
                    mustAuth: true
                },
                index: 3,
            },
            {
                path: 'employee',
                name: 'employee',
                component: require('../views/admin/employee/employeeManage.vue'),
                meta: {
                    title: '员工信息管理',
                    isBackend: true,
                    mustAuth: true
                },
                index: 4,
            },
            {
                path: 'consume',
                name: 'consume',
                component: require('../views/admin/employee/consumeManage.vue'),
                meta: {
                    title: '提交工时管理',
                    isBackend: true,
                    mustAuth: true
                },
                index: 5,
            },
            {
                path: 'holidayConfig',
                name: 'holidayConfig',
                component: require('../views/admin/sys/holidayConfig.vue'),
                meta: {
                    title: '节假日配置',
                    isBackend: true,
                    mustAuth: true
                },
                index: 6,
            },
        ]
    },
    /*==管理后台路由配置 End==*/

    {
        path: '*',
        hidden: true,
        redirect: {path: '/404'}
    }
];


const router = new VueRouter({
    routes
})

router.beforeEach((to, from, next) => {
    NProgress.start();
    if (to.meta.title) {
        document.title = to.meta.title
    }
    const isBackend = to.meta.isBackend

    if (to.matched.some(record => record.meta.mustAuth)) {
        const token = localStorage.getItem('token')
        if (isBackend) {
            if (token) {
                next()
            } else {
                next({path: '/admin/login'})
            }
        } else {
            if (token) {
                next()
            } else {
                next({path: '/login'})
            }
        }
    } else {
        next()
    }
})

router.afterEach(transition => {
    NProgress.done();
})

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js